export const MetaConversionConstants = {
    viewContent: "ViewContent",
    marketingClick: "MarketingClick"
};
